// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "10d8438-dirty",
    "hash": "10d8438",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "10d8438-dirty",
    "semverString": null,
    "frontend": "2.37.5",
    "version": "2.37.5",
    "buildAt": "2026-11-02T15:27:01.225Z",
    "branch": "HEAD"
};
/* tslint:enable */
